module.exports = __webpack_public_path__ + "static/media/YF68_1.acadf6aa.jpg";